import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentMonthAttendance } from "./api"

export const studentMonthAttendanceQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentMonthAttendance', studentNo],
        queryFn: () => getStudentMonthAttendance(studentNo),
    })

export function useStudentMonthAttendance(studentNo: string) {
    return useQuery(studentMonthAttendanceQueryOptions(studentNo))
}

export function useStudentMonthAttendanceSuspense(studentNo: string) {
    return useSuspenseQuery(studentMonthAttendanceQueryOptions(studentNo))
}
